export const todayISO = () => new Date().toISOString().slice(0, 10);

export const normalizeDateISO = (value?: string) => {
  const raw = String(value || '').trim();
  if (!raw) return todayISO();

  let match = raw.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
  if (match) return `${match[1]}-${match[2].padStart(2, '0')}-${match[3].padStart(2, '0')}`;

  match = raw.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
  if (match) return `${match[3]}-${match[2].padStart(2, '0')}-${match[1].padStart(2, '0')}`;

  const parsed = new Date(raw);
  if (!Number.isNaN(parsed.getTime())) return parsed.toISOString().slice(0, 10);
  return todayISO();
};

export const displayDate = (date: string) => {
  const iso = normalizeDateISO(date);
  const [year, month, day] = iso.split('-');
  return `${day}-${month}-${year}`;
};

export const monthKey = (date: string) => normalizeDateISO(date).slice(0, 7);
export const nowISO = () => new Date().toISOString();

export const formatMoney = (value: number) =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(value || 0);

export const addDays = (date: string, days: number) => {
  const d = new Date(normalizeDateISO(date) + 'T00:00:00');
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
};

export const addMonths = (date: string, months: number) => {
  const d = new Date(normalizeDateISO(date) + 'T00:00:00');
  d.setMonth(d.getMonth() + months);
  return d.toISOString().slice(0, 10);
};

export const nextDueDate = (date: string, frequency: string) => {
  if (frequency === 'Weekly') return addDays(date, 7);
  if (frequency === 'Monthly') return addMonths(date, 1);
  if (frequency === 'Quarterly') return addMonths(date, 3);
  if (frequency === 'Half Yearly') return addMonths(date, 6);
  if (frequency === 'Yearly') return addMonths(date, 12);
  return normalizeDateISO(date);
};

export const parseBulkLines = (text: string, defaultType: 'Expense' | 'Income' | 'Investment', defaultPaymentMode: string) =>
  text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line, index) => {
      const [date, category, amount, paymentMode, ...noteParts] = line.split(/[,\t|]/).map((x) => x.trim());
      if (!date || !category || !amount || Number.isNaN(Number(amount))) {
        throw new Error(`Line ${index + 1}: use Date, Category, Amount, Payment Mode, Note`);
      }
      return { date: normalizeDateISO(date), category, amount: Number(amount), paymentMode: paymentMode || defaultPaymentMode, note: noteParts.join(' - '), type: defaultType };
    });
